import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ChapterBasicInfoComponent = ({
    selectLMSChapters, handleInnerFormChange,Modulelist
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Module"
                            labelField="Title"
                            list={Modulelist}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ModuleId'
                                );
                            }}
                            optionName='Choose course'
                            type="select"
                            value={selectLMSChapters?.ModuleId}
                            valueField="ModuleId"
                        />

                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectLMSChapters?.Title}
                        />

                        <InputContainer
                            label="Short Description"
                            labelField="ShortDescription"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ShortDescription'
                                );
                            }}
                            type="text"
                            value={selectLMSChapters?.ShortDescription}
                        />

                        <InputContainer
                            label="DisplayOrder"
                            labelField="DisplayOrder"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DisplayOrder'
                                );
                            }}
                            type="text"
                            value={selectLMSChapters?.DisplayOrder}
                        />

                        <div className='col-span-full'>
                            <InputContainer
                                label="Description"
                                name="Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'Description'
                                    )
                                }}
                                type="rte"
                                value={selectLMSChapters?.Description}
                            />
                        </div>
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default ChapterBasicInfoComponent;
